import React from 'react'
import { cn } from '@/lib/utils/cn'

export interface SpinnerProps {
  /** Size in pixels — maps to width and height */
  size?: 16 | 20 | 24
  /** Accessible label */
  'aria-label'?: string
  /** Additional class names */
  className?: string
  /** Delay before the spinner appears (ms). Prevents flash for fast operations. */
  delayMs?: number
}

/**
 * SVG spinner with configurable size.
 * Respects `prefers-reduced-motion` via CSS (see index.css).
 * Optional appearance delay prevents flash on fast loads.
 */
export function Spinner({
  size = 20,
  'aria-label': ariaLabel = 'Laddar',
  className,
  delayMs,
}: SpinnerProps) {
  return (
    <svg
      className={cn('animate-spin text-current', className)}
      style={{
        width: size,
        height: size,
        ...(delayMs
          ? {
              animationDelay: `${delayMs}ms`,
              animationFillMode: 'backwards',
              opacity: 0,
              animation: `spin 1s linear infinite ${delayMs}ms`,
            }
          : {}),
      }}
      viewBox="0 0 24 24"
      fill="none"
      role="status"
      aria-label={ariaLabel}
    >
      <circle
        className="opacity-25"
        cx="12"
        cy="12"
        r="10"
        stroke="currentColor"
        strokeWidth="3"
      />
      <path
        className="opacity-75"
        fill="currentColor"
        d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
      />
    </svg>
  )
}
